import React, { useState, useEffect } from "react";

import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { styled } from "@mui/system";

import { Card, CardBody, Button, Label } from "reactstrap";

import { chainIds } from "../../../constants";
import Avatar from "../../Avatar";
import CopyClipboard from "../../common/CopyClipboard";
import { useHistory } from "react-router-dom";
import EditPopup from "../../common/EditPopup";
import { addMasterContractCustomImage } from "../../../store/actions/admin";

const AdminMasterContractData = (props) => {
	const { contractID } = props.match.params;
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);

	const { masterContracts } = useSelector((state) => state.admin);
	const [contract, setContract] = useState(null);
	const actualContract = masterContracts.find(
		(item) => item._id === contractID
	);
	const history = useHistory();

	useEffect(() => {
		if (actualContract) {
			setContract(actualContract);
		}
		return () => {
			setContract(null);
		};
	}, [masterContracts, actualContract]);

	const renderUserImg = (item) => {
		console.log(
			"🚀 ~  ~ renderUserImg ~ item?.customImage ?? item?.image",
			item?.customImage,
			item?.image
		);
		return (
			<img
				height="110"
				width="110"
				alt="user-avatar"
				src={
					item?.image.includes("https://")
						? item.image
						: `${process.env.REACT_APP_IPFS_HOST}/${
								item?.customImage ?? item?.image
						  }`
				}
				className="img-fluid rounded mt-3 mb-2"
			/>
		);
	};
	const upgradeVersion = () => {
		history.push(`/administration/contracts/master-upgrade/${contract._id}`);
	};

	const handleChangeText = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const ImageCollection = styled("input")({
		display: "none",
	});
	const handleChangeImage = (event) => {
		let file = event.target.files[0];
		dispatch(addMasterContractCustomImage(contractID, file));
	};

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexBasis: "75%",
			}}
		>
			<Box sx={{ minHeight: "78vh", margin: "0 auto", width: "100%" }}>
				<Card className="mb-3">
					<CardBody style={{ paddingLeft: "70px", paddingRight: "30px" }}>
						<div className="d-flex">
							<div
								className="user-avatar-section me-5"
								style={{
									minHeight: "110px",
									minWidth: "110px",
								}}
							>
								<Box
									className="d-flex align-items-center flex-column position-relative"
									sx={{
										"&:hover svg": { visibility: "visible" },
									}}
								>
									<ImageCollection
										id="custom-image"
										accept="image/png, image/jpeg, image/gif"
										type="file"
										onChange={handleChangeImage}
									/>
									<Label for="custom-image">
										<EditOutlinedIcon
											id="edit-description"
											sx={{
												visibility: "hidden",
												position: "absolute",
												bottom: "-5px",
												right: "-12px",
												cursor: "pointer",
											}}
										/>
									</Label>
									{renderUserImg(contract)}
								</Box>
							</div>
							<div className="info-container" style={{ width: "100%" }}>
								<div className="border-bottom pb-50 mb-1 d-flex justify-content-between">
									<h4 className="fw-bolder ">Details master contract</h4>
								</div>
								<table className="mt-2 mt-xl-0 w-100">
									<tbody>
										<tr className="table-row">
											<th>Version</th>
											<td>
												{contract?.version ?? "No info"}
												<Button
													outline
													disabled={contract?.isDeprecated ?? true}
													className="px-2.5 mx-3 mb-1"
													color="primary"
													onClick={() => upgradeVersion()}
												>
													Upgrade version
												</Button>
											</td>
										</tr>
										<tr className="table-row">
											<th>Name</th>
											<td>
												{contract?.customName ?? contract?.name ?? "- -"}
												<EditOutlinedIcon
													id="master-edit-name"
													sx={{
														ml: "1rem",
														cursor: "pointer",
													}}
													onClick={(event) => handleChangeText(event, "name")}
												/>
											</td>
										</tr>
										<tr className="table-row">
											<th>Network</th>
											<td>{chainIds[contract?.chain]?.name ?? "No info"}</td>
										</tr>
										<tr className="table-row">
											<th>Address</th>
											<td>
												{contract?.address ?? "No info"}
												<CopyClipboard target={contract?.address} />
											</td>
										</tr>
										<tr className="table-row">
											<th>Contract Link</th>
											<td>
												{(
													<a
														href={`${chainIds[contract?.chain]?.link}${
															contract?.address
														}`}
														rel="noreferrer"
														target="_blank"
													>
														link to Etherscan
													</a>
												) || "No info"}
											</td>
										</tr>
										<tr className="table-row">
											<th>IPFS Link</th>
											<td>
												{(
													<a
														href={`${process.env.REACT_APP_IPFS_HOST}/${contract?.meta}`}
														rel="noreferrer"
														target="_blank"
													>
														link
													</a>
												) || "No info"}
											</td>
										</tr>
										<tr className="table-row">
											<th>Description</th>
											<td>
												{contract?.customDescription ?? contract?.description}
												<EditOutlinedIcon
													id="master-edit-description"
													sx={{
														ml: "1rem",
														cursor: "pointer",
													}}
													onClick={(event) =>
														handleChangeText(event, "description")
													}
												/>
											</td>
										</tr>
										<tr className="table-row">
											<th>GAS</th>
											<td>{contract?.gas ?? "No info"}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</CardBody>
				</Card>
			</Box>
			<EditPopup
				anchorEl={anchorEl}
				setAnchorEl={setAnchorEl}
				contractId={contractID}
			/>
		</Box>
	);
};

export default withRouter(AdminMasterContractData);
